import { Injectable } from '@angular/core';
var BsModalRef = (function () {
    function BsModalRef() {
        /**
         * Hides the modal
         */
        this.hide = Function;
    }
    BsModalRef.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsModalRef.ctorParameters = function () { return []; };
    return BsModalRef;
}());
export { BsModalRef };
//# sourceMappingURL=bs-modal-ref.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/modal/bs-modal-ref.service.js
// module id = 457
// module chunks = 3